import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductMeta extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateMeta);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateMeta);
  }

  /**
   * Updates vendor/SKU on variant change.
   * @param {VariantUpdateEvent} event
   */
  updateMeta = (event) => {

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newMeta = event.detail.data.html.querySelector('product-meta');

    if (!newMeta) {
      return;
    }

    // Log before morph
    const newSku = newMeta.querySelector('.product-meta__sku span')?.textContent.trim();

    morph(this, newMeta, { childrenOnly: true });

    // Log after morph
    const updatedSku = this.querySelector('.product-meta__sku span')?.textContent.trim();
  };
}

if (!customElements.get('product-meta')) {
  customElements.define('product-meta', ProductMeta);
}
